import { CdkColumnDef } from '@angular/cdk/table';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { VesselStatusPopupComponent } from 'src/app/shared/components/vessel-status-popup/vessel-status-popup.component';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import {
  applyUsernameClientFilter,
  extractClientOptionsFromRecords,
  extractSegmentOptionsFromRecords,
  matchesAnyClient,
  matchesAnySegment,
  matchesDateRange,
  resolveRecordDate,
} from 'src/app/shared/helpers/pc-filter-options.util';
import {
  clampPageIndex,
  getPaginatedRowSerialNumber,
  slicePage,
} from 'src/app/shared/helpers/pc-client-pagination.util';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { DEMO_VESSEL_PC } from 'src/app/shared/helpers/heating-table-dynamic-extract.util';

@Component({
  selector: 'app-charter-performance-pc',
  templateUrl: './charter-performance-pc.component.html',
  styleUrls: ['./charter-performance-pc.component.scss'],
})
export class CharterPerformancePCComponent implements OnInit, AfterViewInit {
  @ViewChildren(CdkColumnDef) columnDefs!: QueryList<CdkColumnDef>;
  filterForm!: FormGroup;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('table', { static: false }) table!: ElementRef;
  paginatedData: any[] = [];
  itemsPerPage: number = 15;
  pageIndex: number = 0;
  elements: any[] = [];
  counter = 1;
  clientOptions: string[] = [];
  segmentOptions: string[] = [];
  selectedSegments: string[] = [];
  selectedClients: string[] = [];
  filteredData: any[] = [];
  selectedTab: boolean | undefined;
  pastVoyagesComponent: any;
  data: any;
  shipNameSuggestions: any[] = [];
  edit: boolean = false;
  length = 0;
  username: any;
  isFilterOpen = false;
  subusername: any;
  isLoadingTable: boolean = true;
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private sharedDataService: DashboardService,
    private requestFormService: RequestFormService,
    private prequestFormService: PortRequestFormServiceService,
    private dialog: MatDialog,
  ) {
    this.filterForm = this.fb.group({
      from_date: [''],
      to_date: [''],
      shipName: [''],
      imoNumber: [''],
    });
  }
  ngOnInit() {
    this.username = localStorage.getItem('username') ?? '';
    this.subusername = localStorage.getItem('loginPic') ?? '';
    this.loadFilterOptions();
    if (this.username !== 'Eiger Shipping') {
      this.loadData();
    }

    // this.paginateData();
  }

  loadFilterOptions(): void {
    this.prequestFormService.getTrackerData().subscribe((data) => {
      const records = applyUsernameClientFilter(data || [], this.username);
      this.clientOptions = extractClientOptionsFromRecords(records);
      this.segmentOptions = extractSegmentOptionsFromRecords(records);
      this.refreshSegmentOptionsFromElements();
    });
  }

  private refreshSegmentOptionsFromElements(): void {
    const merged = new Set([
      ...(this.segmentOptions || []),
      ...extractSegmentOptionsFromRecords(this.elements || []),
    ]);
    this.segmentOptions = Array.from(merged).sort((a, b) => a.localeCompare(b));
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }

  @HostBinding('class.pc-light') get pcLight(): boolean {
    return !this.isDarkMode();
  }
  isMerakiOperations(): boolean {
    return this.username === 'Meraki - Operations';
  }
  refresh() {
    if (this.username !== 'Eiger Shipping') {
      this.loadData();
    }
  }
  loadData() {
    this.isLoadingTable = true;
    const from_date_str = this.filterForm.get('from_date')?.value;
    const to_date_str = this.filterForm.get('to_date')?.value;
    const shipName = this.filterForm.get('shipName')?.value;
    const imoNumber = this.filterForm.get('imoNumber')?.value;

    this.paginatedData = [];

    this.prequestFormService.getCharterPerformance(true).subscribe((res: any) => {
      let charterData = res.data || [];

      // Filter to show only active vessels (vessel_status = true) and hide all inactive vessels
      charterData = charterData.filter(
        (item: any) =>
          item.vessel_status === true ||
          String(item.vessel_status).toLowerCase() === 'true',
      );

      if (this.subusername?.toLowerCase() === 'grace') {
        charterData = charterData.filter(
          (item: any) => String(item.vessel_imo) !== '9397456',
        );
      }
      if (this.subusername?.toLowerCase() === 'demo') {
        charterData = charterData.filter((item: any) =>
          DEMO_VESSEL_PC.includes(String(item.vessel_imo)),
        );
      }

      this.data = charterData;
      // ✅ TABLE DATA MAP
      this.elements = this.data.map((item: any, index: number) => {
        const originalImo = String(item.vessel_imo ?? '');

        const isDemo = this.subusername?.toLowerCase() === 'demo';

        return {
          sNo: index + 1,

          // Keep original values for API/navigation
          original_vessel_imo: originalImo,
          original_vessel_name: item.vessel_name,
          orgnal_client_name: item.client,
          vessel_status: item.vessel_status,

          // Display values
          shipName: isDemo
            ? originalImo === '9399480'
              ? 'Vessel 1'
              : 'Vessel 2'
            : item.vessel_name || '__',

          imoNumber: isDemo ? 'XXXXXXX' : item.vessel_imo || '__',

          client: isDemo
            ? originalImo === '9399480'
              ? 'Client 1'
              : 'Client 2'
            : item.client || '__',
          segment: item.segment || '__',
          port: item.port || '__',
          operation: item.operations || '__',

          reportDate: resolveRecordDate(item, [
            'report_date',
            'last_report_date',
            'last_report_date_time',
            'updated_at',
          ]),

          totalGainLoss: item.total_gain_loss ?? 0,

          actualConsumption: {
            HSFO: item.actual_consumptions_mt_hsfo ?? 0,
            VLSFO: item.actual_consumptions_mt_vlsfo ?? 0,
            MGO: item.actual_consumptions_mt_lsgo ?? 0,
          },

          cpConsumption: {
            HSFO: item.cp_warranted_consumptions_mt_hsfo ?? 0,
            VLSFO: item.cp_warranted_consumptions_mt_vlsfo ?? 0,
            MGO: item.cp_warranted_consumptions_mt_lsgo ?? 0,
          },

          lossGain: {
            HSFO: item.cp_warranted_loss_or_gain_hsfo ?? 0,
            VLSFO: item.cp_warranted_loss_or_gain_vlsfo ?? 0,
            MGO: item.cp_warranted_loss_or_gain_lsgo ?? 0,
          },
        };
      });

      // ✅ FILTER RESET (IMPORTANT FOR PAGINATION)
      this.filteredData = [...this.elements];
      this.refreshSegmentOptionsFromElements();

      this.resetPagination();
      this.isLoadingTable = false;
    });
  }

  filterShipNames(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (inputValue.length > 0) {
      this.shipNameSuggestions = (this.elements || []).filter((item: any) =>
        String(item.shipName || '')
          .toLowerCase()
          .includes(inputValue),
      );
    } else {
      this.shipNameSuggestions = [];
    }
  }
  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort: Sort) => {
      this.sortData(sort);
    });
  }
  getTotalLossGain(element: any) {
    return (
      (element.lossGain.HSFO || 0) +
      (element.lossGain.VLSFO || 0) +
      (element.lossGain.MGO || 0)
    );
  }
  paginateData(): void {
    const source = this.filteredData ?? [];
    this.pageIndex = clampPageIndex(
      this.pageIndex,
      source.length,
      this.itemsPerPage,
    );
    this.paginatedData = slicePage(source, this.pageIndex, this.itemsPerPage);
    this.length = source.length;

    if (this.paginator) {
      this.paginator.length = this.length;
      this.paginator.pageIndex = this.pageIndex;
    }
  }

  private resetPagination(): void {
    this.pageIndex = 0;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.paginateData();
  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.itemsPerPage = event.pageSize || this.itemsPerPage;
    this.paginateData();
  }

  sortData(sort: Sort): void {
    const source = [...(this.filteredData ?? [])];
    if (!sort.active || sort.direction === '') {
      this.filteredData = [...(this.elements ?? [])];
      this.resetPagination();
      return;
    }

    const isAsc = sort.direction === 'asc';
    this.filteredData = source.sort((a: any, b: any) =>
      this.compare(a, b, isAsc, sort.active),
    );
    this.resetPagination();
  }

  compare(a: any, b: any, isAsc: boolean, column: string) {
    let valueA = this.getNestedValue(a, column);
    let valueB = this.getNestedValue(b, column);

    if (valueA === null || valueA === undefined) return isAsc ? -1 : 1;
    if (valueB === null || valueB === undefined) return isAsc ? 1 : -1;

    const numericalColumns = ['timeLost', 'hsfo', 'vlsfo', 'go'];
    if (numericalColumns.includes(column)) {
      valueA = parseFloat(valueA);
      valueB = parseFloat(valueB);
      return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
    }

    return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
  }

  getNestedValue(obj: any, column: string) {
    switch (column) {
      case 'hsfo':
      case 'vlsfo':
      case 'go':
        return obj.bunkerLostOrGain[column.toUpperCase()];
      default:
        return obj[column];
    }
  }
 showDetails(row: any) {
  if (!row || !row.shipName || !row.imoNumber) {
    return;
  }
  const originalImo = String(row.original_vessel_imo);

  const isDemo =
    this.subusername?.toLowerCase() === 'demo';

  // Always store ORIGINAL values for API
  this.sharedDataService.setRowData({
    ...row,
    original_vessel_name: row.original_vessel_name,
    original_vessel_imo: originalImo,
  });

  this.router.navigate(['/pc-inside-charter-view'], {
    queryParams: {
      vesselName: isDemo
        ? originalImo === '9399480'
          ? 'Vessel 1'
          : 'Vessel 2'
        : row.shipName,

      imo: isDemo ? 'XXXXXXX' : originalImo,

      segment: row.segment || '',
    }
  });
}

  formatLossGainValue(value: number | null | undefined): string {
    if (value === 0 || value == null) {
      return '--';
    }
    return Number(value).toFixed(2);
  }

  getLossGainStyle(value: number | null | undefined): Record<string, string> {
    if (value == null || value === 0) {
      return {};
    }
    if (value > 0) {
      return { color: '#52c41a' };
    }
    return { color: '#ff4d4f' };
  }
  downloadIcon(ow: any) {
    this.toastr.success(ToasterMessages.UnderDev);
  }

  editedRowIndex: number | null = null;
  editedColumnName: string | null = null;
  editCell(rowIndex: number, columnName: string) {
    this.editedRowIndex = rowIndex;
    this.editedColumnName = columnName;
  }
  exitEdit() {
    this.editedRowIndex = null;
    this.editedColumnName = null;
  }
  calculateClaimableAmount(element: any) {
    const claimEst = element.claimEst;
    const fuelLost = element.bunkerLostOrGain;

    if (
      claimEst === null ||
      claimEst === undefined ||
      claimEst.hire === '' ||
      claimEst.bunkPrice === ''
    ) {
      return '__';
    }
    const HSFO = fuelLost && fuelLost.HSFO === '__' ? 0 : fuelLost.HSFO;
    const VLSFO = fuelLost && fuelLost.VLSFO === '__' ? 0 : fuelLost.VLSFO;
    const GO = fuelLost && fuelLost.GO === '__' ? 0 : fuelLost.GO;
    const bunkPrice =
      claimEst && claimEst.bunkPrice !== null ? claimEst.bunkPrice : 0;
    const hireClaim = claimEst ? claimEst.hire * (element.timeLost / 24) : 0;
    const fuelClaim = fuelLost
      ? bunkPrice * (HSFO || 0) +
        bunkPrice * (VLSFO || 0) +
        bunkPrice * (GO || 0)
      : 0;

    const totalClaim = hireClaim + fuelClaim;

    return isNaN(totalClaim) || totalClaim === undefined
      ? '__'
      : Math.round(totalClaim);
  }
  clearClick() {
    this.filterForm.reset();
    this.selectedSegments = [];
    this.selectedClients = [];

    this.filteredData = [...this.elements];
    this.resetPagination();
    this.isFilterOpen = false;
  }

  closeFilterDrawer(): void {
    this.isFilterOpen = false;
  }

  getRowSerialNumber(index: number): number {
    return getPaginatedRowSerialNumber(
      this.pageIndex,
      this.itemsPerPage,
      index,
    );
  }

  filterClick() {
    const formValues = this.filterForm.value;

    const shipName = formValues.shipName?.toLowerCase()?.trim();
    const imoNumber = String(formValues.imoNumber ?? '').trim();

    this.filteredData = (this.elements || []).filter((item: any) => {
      const matchesDate = matchesDateRange(
        item.reportDate,
        formValues.from_date,
        formValues.to_date,
      );

      const matchesShip =
        !shipName ||
        String(item.shipName || '')
          .toLowerCase()
          .includes(shipName);

      const matchesIMO =
        !imoNumber || String(item.imoNumber ?? '').includes(imoNumber);

      return (
        matchesDate &&
        matchesAnyClient(item.client, this.selectedClients) &&
        matchesAnySegment(item.segment, this.selectedSegments) &&
        matchesShip &&
        matchesIMO
      );
    });

    this.resetPagination();
    this.isFilterOpen = false;

    if (this.filteredData.length === 0) {
      this.toastr.info('No matching records found');
    }
  }
  exportClick() {
    const data = this.elements;
    const csvHeader =
      'Ship Name,Segment,Time Lost (or) Gain,HSFO,VLSFO,GO,Daily Hire,Avg Bunker Price,Claimable Amount';
    const csvData = data
      .map((item: any) => {
        const bunkLostGain = item.bunkerLostOrGain
          ? `${item.bunkerLostOrGain.HSFO},${item.bunkerLostOrGain.VLSFO},${item.bunkerLostOrGain.GO}`
          : ',,';
        const claimEst = item.claimEst
          ? `${item.claimEst.hire},${item.claimEst.bunkPrice}`
          : ',';
        return `${item.shipName},${item.segment},${
          item.timeLost
        },${bunkLostGain},${claimEst},${this.calculateClaimableAmount(item)}`;
      })
      .join('\n');
    const csvContent = `${csvHeader}\n${csvData}`;
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'table_data.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  printTable() {
    // Use all elements or filteredData based on what you want to print
    const dataToPrint = this.filteredData || this.elements;

    // Generate the HTML content for the table
    const tableHtml = `
      <html>
        <head>
          <style>
          
  .tableTitle {
    display: block;
    position:fixed; 
    top: 0px !important;
    left: 10px !important;
    width: 100%;
    font-size: 1.2em;
    margin-bottom: 10px; 
     color: #766b6b;
     font-family: "Poppins", sans-serif;
     page-break-before: avoid;
  }
  .printable-table {
    position: absolute;
    max-height: 100%;
    top: 50px;
    page-break-inside:avoid;
  }
  .filter{
    display: none;
  }
  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
     @page {
              size: A4;
              margin: 0; /* Remove margins */
            }

  table {
    width: 100%;
    min-width: 100%;
    border: 0;
    white-space: nowrap;
    border-spacing: 0;
    box-shadow: 0px 0px 20px 0px rgba(82, 63, 105, 0.15);
  }
  th.time {
    white-space: nowrap;
  }
  .scroll-bar {
    overflow-x: scroll !important;
    overflow-y: hidden;
  }
  th,
  td {
    min-width: 85px;
    font-weight: 500;
    font-family: "Poppins", sans-serif;
    text-align: center !important;
    vertical-align: middle;
    padding-top: 0px;
    padding-bottom: 0px;
    font-size: 13px;
  }
  th {
    background-color: #0a4380d9;
    color: white;
    border: 1px solid #8d8e8f;
    padding-left: 5px;
    padding-right: 5px;
  }
  td {
    color: #766b6b;
    white-space: nowrap;
    padding:10px
  }
  tr {
    &:nth-child(even) {
      background-color: #cbeaf0;
    }
    &:nth-child(odd) {
      background-color: #f5fdff;
    }
  }
     .logo {
            position: absolute;
            top: 0px;
            right: 10px;
            width: 65px;
          }
          </style>
        </head>
        <body>
         <img src="../../../assets/images/logo.png" class="logo" />
          <h2 class="tableTitle">Fleet View Table</h2>
          <table class="printable-table">
            <thead>
              <tr>
               <th   rowspan="2">S.No</th>
              <th   rowspan="2">Ship Name</th>
              <th   rowspan="2">IMO Number</th>
              <th   rowspan="2">Segment</th>
              <th   rowspan="2">Time Lost</th>
              <th colspan="3"> Bunker Lost(-) or Gained(mt)</th>
              </tr>
              <tr>
                <th class="th-text-center2" mat-sort-header="hsfo"><span>HSFO</span></th>
                <th class="th-text-center2" mat-sort-header="vlsfo"><span>VLSFO</span></th>
                <th class="th-text-center2" mat-sort-header="go"><span>GO</span></th>
              </tr>
            </thead>
            <tbody>
              ${dataToPrint
                .map(
                  (item: any, index: number) => `
                <tr>
                  <td>${index + 1}</td>
                  <td>${item.shipName}</td>
                  <td>${item.imoNumber}</td>
                  <td>${item.segment}</td>
                  <td>${item.timeLost}</td>
                  <td>${item.bunkerLostOrGain.HSFO}</td>
                  <td>${item.bunkerLostOrGain.VLSFO}</td>
                  <td>${item.bunkerLostOrGain.GO}</td>
                </tr>
              `,
                )
                .join('')}
            </tbody>
          </table>
        </body>
      </html>
    `;

    // Create a new iframe element for printing
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);

    const iframeDocument =
      iframe.contentDocument || iframe.contentWindow?.document;

    if (iframeDocument) {
      iframeDocument.open();
      iframeDocument.write(tableHtml);
      iframeDocument.close();

      // Trigger print
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();

      // Clean up
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    }
  }

  downloadClick() {
    this.toastr.success(ToasterMessages.UnderDev);
  }
  tabChanged(event: MatTabChangeEvent) {
    // this.selectedTab = !this.selectedTab;
    // if (this.pastVoyagesComponent) {
    //   this.pastVoyagesComponent.refresh();
    // }
  }
  editClick() {
    this.edit = true;
  }
  onCheckboxChange(event: Event, element: any) {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
      const dialogRef = this.dialog.open(VesselStatusPopupComponent, {
        width: '400px',
        height: '228px',
        disableClose: true,
        data: {
          reasonOptions: element.vessel_status, // Pass reason options
        },
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          let payload = {
            imo: element.imoNumber,
            reason: result.reason,
            status: result.status,
          };
          this.sharedDataService
            .updateStatus(payload)
            .subscribe((data: any) => {
              this.edit = false;
              this.toastr.success(ToasterMessages.SuccessMessage);
              this.loadData();
            });
        }
      });
    }
  }

  private segmentColorMap: { [key: string]: string } = {
    mr: '#c27036',
    handymax: '#369047',
    suezmax: '#6a6a6a',
    vlcc: '#3249d4',
    aframax: '#7e3b3b',
    'gas tanker': '#5b5418',
    handy: '#35707b',
    lr1: '#2a644f',
    lr2: '#556ba6',
    coaster: '#859914ff',
    handysize: '#541e85',
    supramax: '#6b181f',
    ultramax: '#85501c',
    panamax: '#723768',
    kamsarmax: '#077c5f',
    'ultra panamax': '',
    capesize: '#7c7440',
    chinamax: '',
    'lr1/panamax': '#42bfaaff',
    'lr2/aframax': '#427ebf',
    'lr3/suezmax': '#bf4281ff',
    bitumen: '#7b4d75',
  };

  getDynamicSegmentStyle(segment: string): any {
    if (!segment) return {};

    const key = segment.toLowerCase();

    // If NOT in static mapping → assign dynamic color
    if (!this.segmentColorMap[key]) {
      this.segmentColorMap[key] = this.generateDarkColorFromText(key);
    }

    const color = this.segmentColorMap[key];

    return {
      'background-color': color,
      'border-radius': '12px',
      padding: '0px 6px',
      color: '#fff',
      display: 'inline-block',
      'font-weight': '500',
      'text-transform': 'uppercase',
      'font-size': '12px',
      'letter-spacing': '0.5px',
    };
  }

  /** Generates a consistent dark color for unknown segments */
  private generateDarkColorFromText(text: string): string {
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }

    let r = (hash >> 16) & 0xff;
    let g = (hash >> 8) & 0xff;
    let b = hash & 0xff;

    // Force dark tones
    r = Math.floor(r * 0.4);
    g = Math.floor(g * 0.4);
    b = Math.floor(b * 0.4);

    return `rgb(${r}, ${g}, ${b})`;
  }

  goBack(): void {
    this.router.navigate(['/pc-home']);
  }
}
